import { Component, h } from "preact";

export interface IOptionItem {
  label: string;
  value: string;
}

interface IProps {
  items: Array<string | IOptionItem>;
  label?: string;
  onChange: (newvalue: string[]) => void;
  defaultValue?: string;
}

interface IState {
  selected?: string;
}
export const Select = class extends Component<IProps, IState> {
  public componentWillMount() {
    const selectedValue = this.props.defaultValue;
    this.setState({
      selected: selectedValue,
    });
    this.props.onChange([selectedValue ? selectedValue : ""]);
  }

  public render(intraProps: IProps) {
    return (
      <div class="form-group">
        {intraProps.label ? <label>{intraProps.label}</label> : null}
        <select
          class="form-control"
          onChange={this.onchange.bind(this)}
          value={this.state.selected}
        >
          {intraProps.items.map(this.renderItem)}
        </select>
      </div>
    );
  }

  private renderItem(item: string | IOptionItem) {
    if (typeof item === "string") {
      return <option>{item}</option>;
    } else {
      return <option value={item.value}>{item.label}</option>;
    }
  }

  private onchange(event: any) {
    const newValue = (event.target as HTMLInputElement).value;
    this.setState({
      selected: newValue,
    });
    if (this.props.onChange) {
      this.props.onChange([newValue]);
    }
  }
};
